/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_UsageInputs */

const en_admin_resource_form_usage = /** @type {(inputs: Admin_Resource_Form_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage`)
};

const de_admin_resource_form_usage = /** @type {(inputs: Admin_Resource_Form_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzungsart`)
};

const es_admin_resource_form_usage = /** @type {(inputs: Admin_Resource_Form_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de uso`)
};

const fr_admin_resource_form_usage = /** @type {(inputs: Admin_Resource_Form_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisation`)
};

/** @type {(inputs: Admin_Resource_Form_UsageInputs) => LocalizedString} */
const it_admin_resource_form_usage = en_admin_resource_form_usage;

/** @type {(inputs: Admin_Resource_Form_UsageInputs) => LocalizedString} */
const pt_br2_admin_resource_form_usage = en_admin_resource_form_usage;

/** @type {(inputs: Admin_Resource_Form_UsageInputs) => LocalizedString} */
const pl_admin_resource_form_usage = en_admin_resource_form_usage;

/** @type {(inputs: Admin_Resource_Form_UsageInputs) => LocalizedString} */
const hu_admin_resource_form_usage = en_admin_resource_form_usage;

/** @type {(inputs: Admin_Resource_Form_UsageInputs) => LocalizedString} */
const ro_admin_resource_form_usage = en_admin_resource_form_usage;

/**
* | output |
* | --- |
* | "Usage" |
*
* @param {Admin_Resource_Form_UsageInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_usage = /** @type {((inputs?: Admin_Resource_Form_UsageInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_UsageInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_usage(inputs)
	if (locale === "de") return de_admin_resource_form_usage(inputs)
	if (locale === "es") return es_admin_resource_form_usage(inputs)
	if (locale === "fr") return fr_admin_resource_form_usage(inputs)
	if (locale === "it") return it_admin_resource_form_usage(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_usage(inputs)
	if (locale === "pl") return pl_admin_resource_form_usage(inputs)
	if (locale === "hu") return hu_admin_resource_form_usage(inputs)
	return ro_admin_resource_form_usage(inputs)
});
export { admin_resource_form_usage as "admin.resource_form.usage" }